<template>
  <pb-modal v-model="_toggle" width="400" @confirm="confirmHandler">
    <template slot="header">
      사용자 추가
    </template>

    <pb-divider>
      <pb-input v-model="create.name" size="small" placeholder="이름" />
    </pb-divider>

    <pb-divider>
      <pb-input v-model="create.id" size="small" placeholder="아이디" />
    </pb-divider>

    <pb-divider>
      <pb-input
        v-model="create.password"
        type="password"
        size="small"
        placeholder="패스워드"
      />
    </pb-divider>
  </pb-modal>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "AddCampaignModal",
  data: () => ({
    create: {
      name: null,
      id: null,
      password: null,
    },
  }),
  props: {
    value: Boolean,
  },
  computed: {
    _toggle: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    ...mapActions(["ADD_USER"]),

    clearData() {
      this.craete = {
        name: null,
        id: null,
        password: null,
      };
    },

    confirmHandler() {
      if (!this.create.name) {
        this.$alert.error("이름을 작성해주세요.");
        return;
      }

      if (!this.create.id) {
        this.$alert.error("아이디를 작성해주세요.");
        return;
      }

      if (!this.create.password) {
        this.$alert.error("패스워드를 작성해주세요.");
        return;
      }

      this.ADD_USER({ payload: this.create })
        .then(() => {
          this.$alert.info("사용자가 정삭적으로 추가되었습니다.");
          this.$emit("input", false);
          this.$emit("reload");
        })
        .catch((error) => {
          let message = "오류발생";

          if (error.data === "no id") {
            message = "아이디를 작성해주세요.";
          }

          if (error.data === "no password") {
            message = "패스워드를 작성해주세요.";
          }

          if (error.data === "no name") {
            message = "이름을 작성해주세요.";
          }

          this.$alert.error(message);
        });
    },
  },
};
</script>
<style lang="scss"></style>
